import { cn } from '@/core/utils/common'

import type { ReactNode } from 'react'

/*
 * 애니 · 게임 연출 조각 — 장식 전용(aria-hidden, 누를 수 없음). 모션 줄이기면 멈춘다.
 * 한 화면에 한두 번만: 히어로 · 보상 · 단계 상승 · 레어 카드처럼 "순간"에만 쓰고, 목록 전체에 뿌리지 않는다.
 * CSS 는 globals.css 의 speed-lines · title-glow · slash-in.
 */

/** 만화 집중선 — 부모(relative)를 가득 채운다. 가운데는 비어 주인공을 가리지 않는다 */
export function SpeedLines({
  className,
  pulse = true,
}: {
  className?: string
  pulse?: boolean
}) {
  return (
    <span
      aria-hidden="true"
      className={cn(
        'pointer-events-none absolute inset-0 speed-lines',
        pulse && 'animate-lines-pulse motion-reduce:animate-none',
        className
      )}
    />
  )
}

const SKEW_TONE = {
  point: 'bg-point text-inverse',
  gold: 'bg-sub text-gem-ink',
  white: 'bg-foreground text-background',
  glass: 'bg-black/50 text-t1 backdrop-blur-md',
} as const

/** 게임식 기울인 라벨(NEW! · 1위 · 레어) — 바탕만 기울이고 글자는 바로 세운다 */
export function SkewTag({
  children,
  tone = 'point',
  className,
}: {
  children: ReactNode
  tone?: keyof typeof SKEW_TONE
  className?: string
}) {
  return (
    <span
      className={cn(
        'inline-flex h-6 -skew-x-12 items-center rounded-control px-2.5',
        SKEW_TONE[tone],
        className
      )}
    >
      <span className="inline-flex skew-x-12 items-center gap-1 text-c12 leading-none font-black tracking-[-0.01em]">
        {children}
      </span>
    </span>
  )
}
